export function getQuotedMessageSenderName(quotedMessage) {

  const sender = quotedMessage.sender || {};

  return sender.fullName || sender.fromName || sender.fromEmailAddress || sender.email || '';

}

export function getQuotedMessageText(quotedMessage) {

  const serializedContent = quotedMessage.serializedContent || {};

  return (serializedContent.text || '').trim();

}
